export const PARTNERS = {
    TMOBILE: 'tmobile',
    VERIZON: 'verizon',
    WALMARTPLUS: 'walmartplus',
    DELTA: 'delta',
};
